import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextPartsPageAction, prevPartsPageAction, setPartsPageSizeAction } from '../../redux/actions/partsActions';

const PartsPagination = () => {
  const pageable = useSelector((state) => state.parts?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextPartsPageAction}
      onPrevPageClickAction={prevPartsPageAction}
      onPageSizeChangeAction={setPartsPageSizeAction}
    />
  );
};

export default PartsPagination;
